import { render, staticRenderFns } from "./SideView.vue?vue&type=template&id=3b2c00fa"
import script from "./SideView.vue?vue&type=script&lang=js"
export * from "./SideView.vue?vue&type=script&lang=js"
import style0 from "./SideView.vue?vue&type=style&index=0&id=3b2c00fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports